import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Banner } from '../../../../../../components/Banner/desktop'
import LayoutInstitution from '../../../../../../components/LayoutInstitution/desktop'
import Map from '../../../../../../components/Map'
import { SOCIAL_ICONS } from '../constants'
import { useContacts } from '../bll/useContacts'
import { useBannerProgramTypes } from '../../utils/useBannerProgramTypes'
import { isPaidPackage } from '../../utils/isPaidPackage'

const Link = styled.a`
  color: ${sv.color.blue};
`

const Dot = styled.span`
  &:before {
    content: ' • ';
    color: ${sv.color.gray25};
  }
`

const ContactsPage: FC = () => {
  const { email, phoneNumbers, pins, socialAccounts, webSite, addresses, webSiteName } =
    useContacts()

  const { extraParams, paidPackage } = useBannerProgramTypes()

  const center = useMemo(() => {
    if (pins && pins.length > 0) {
      const pin = pins[0]

      if (pin && pin.latitude && pin.longitude) {
        return [pin.longitude, pin.latitude]
      }

      return undefined
    }

    return undefined
  }, [pins])

  return (
    <>
      <LayoutInstitution>
        <Heading as='h1' h2='Контактная информация' spacing='large' />

        {!!pins.length && (
          <>
            <Map
              zoomControl
              fullscreenControl
              pins={pins}
              componentHeight={291}
              center={center}
            />

            <Spacing spacing='xlarge' />
          </>
        )}

        {addresses.map(({ name, location }, index) => (
          <>
            <Text key={index} fontSize='h5' lineHeight='h5'>
              {name}
              {location && ` г. ${location.name}`}
            </Text>

            <Spacing spacing='xsmall' />
          </>
        ))}

        <Text html={false} fontSize='h5' lineHeight='h5'>
          {phoneNumbers?.flatMap(({ phone }, index) => (
            <>
              {phone}

              {index !== phoneNumbers.length - 1 && <Dot />}
            </>
          ))}

          {webSite && (
            <>
              <Dot />

              <Link target='_blank' href={webSite}>
                {webSiteName}
              </Link>
            </>
          )}

          {email && (
            <>
              <Dot />

              <Link href={`mailto:${email}`}>{email}</Link>
            </>
          )}
        </Text>

        {!!socialAccounts.length && (
          <>
            <Spacing spacing='xxsmall' />

            {socialAccounts.map(({ url, type }) => {
              const Icon = SOCIAL_ICONS[type.value]

              if (Icon) {
                return (
                  <Button key={url} view='link' icon href={url} target='_blank'>
                    {Icon ? <Icon width='20px' height='20px' /> : type.name}
                  </Button>
                )
              }

              return null
            })}
          </>
        )}

        <Spacing spacing='uxlarge' />
      </LayoutInstitution>

      {!isPaidPackage(paidPackage) && <Banner id={6} extraParams={extraParams} />}

      {!isPaidPackage(paidPackage) && <Banner id={14} extraParams={extraParams} />}
    </>
  )
}

export default ContactsPage
